export default () => {
    return [
        {
            path: '/produzioneCommerciale',
            name: 'produzioneCommerciale',
            component: () => import('./views/produzioneCommerciale.vue'),
        },
    ];
};
